//
//
//
//
//
//

import { secondToMinutes } from '@motionelements/helper/tools.js';

export default {
  name: 'product-card-info-item-duration',
  props: {
    element: Object,
  },
  computed: {
    duration() {
      return _.get(this.element, 'mediaTypeDetails.duration');
    },
    durationToMinutes() {
      return this.duration ? secondToMinutes(this.duration) : '00:00';
    },
  },
};
